import Box from "@mui/material/Box";

//#region Interfaces ... 
interface IGridBoxProps {
    getData: () => any[];
    minRowHeight?: number;
    children: React.ReactNode;
}
//#endregion


const GridBox = (props: IGridBoxProps) => {
    const { getData, minRowHeight, children } = props;
    return (
        <Box sx={{
            backgroundColor: '#F7F7F7',
            fontFamily: 'Open Sans',
            width: 'inherit',
            '& .header': {
                color: '#555555',
            },
            '& .MuiDataGrid-headerFilterRow': {
                borderBottom: getData != undefined && getData().length === 0 ? '0' : '2px solid #001A69 !important'
            },
            '& .row': {
                minHeight: minRowHeight ? `${minRowHeight.toString()}px !important` : '',
                '&:not(.validation-error, .validation-success):hover': {
                    backgroundColor: '#D9EEFF !important',
                },
            },
            '& .odd': {
                backgroundColor: '#F7F7F7',
            },
            '& .even': {
                backgroundColor: '#ffffff',
            },
            '& .error': {
                backgroundColor: ' #ce261c30 !important',
            },
            '& .MuiDataGrid-cell:not(.MuiDataGrid-cellCheckbox)': {
                borderBottom: 'none',
                display: 'flex',
                alignItems: 'center'
            },
            '& .MuiDataGrid-sortIcon': {
                fontSize: '24px'
            },
        }}>
            {children}
        </Box>
        );
}

export default GridBox;